module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.8bc81da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_arrow_right.svg
// module id = 1198
// module chunks = 0